import { Pipe, PipeTransform } from "@angular/core";
import { KeycloakHelperService } from "@core/services";

@Pipe({
    name: "mileageUnitLength",
    standalone: false
})
export class MileageUnitLengthPipe implements PipeTransform {
  constructor(private keycloakHelperService: KeycloakHelperService) {}

  transform(value: string | number): string | number {
    if (value === null || value === undefined) {
      return value;
    }

    if (this.keycloakHelperService.isNorthAmerican()) {
      return `${value} Mileage`;
    }

    return `${value} km`;
  }
}
